
import React, { Component } from 'react';
import { Input, Button, Row } from 'reactstrap';
import { BottomSheet } from 'react-spring-bottom-sheet'
import { RiDeleteBin5Line } from "react-icons/ri";
import SubModifierComponent from './subModifierComponent';

const modelUtil = require('../../../../utils/basket/modelUtil.js');
const formatter = require('../../../../utils/formatter/formatter.js');

class ModifierComponent extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.modifierModel = this.props.modifierModel;
        this.state.itemModel = this.props.itemModel;

        this.state.selectedModifierModel = null;
    }

    render()
    {
        var headerComponent = <div style={{fontWeight:'bold'}}>{this.state.modifierModel.modifier.caption}</div>

        var footerComponent = <div style={{textAlign:'center'}}>
                                    <Button disabled={!modelUtil.isItemModelFullySatisfied(this.state.modifierModel)} 
                                            style={{
                                                color:`var(--button-addToBasket-font-color)`, 
                                                background:`var(--button-addToBasket-background-color)`,
                                                borderColor:`var(--button-addToBasket-background-color)`,
                                                fontSize:`var(--button-addToBasket-font-size)`,
                                                fontWeight:'bold',
                                                marginRight:'5px',
                                                paddingLeft:'20px',
                                                paddingRight:'20px',
                                                paddingTop:'10px',
                                                paddingBottom:'10px',
                                            }}
                                            onClick={()=>{this.props.onDismiss()}}>
                                        Add To Basket - {formatter.convertToCurrencyFormat(modelUtil.getItemModelTotalPrice(this.state.itemModel))}
                                    </Button> 
                              </div>

        if (this.state.selectedModifierModel != null)
        {
            return <ModifierComponent modifierModel={this.state.selectedModifierModel} 
                                  itemModel={this.state.itemModel}
                                  onDismiss={()=>
                                {
                                    if (!modelUtil.isItemModelFullySatisfied(this.state.selectedModifierModel))
                                    {
                                        modelUtil.removeItemModel(this.state.selectedModifierModel);
                                    }

                                    this.state.selectedModifierModel = null;
                                    this.setState({});
                                }}/>
        }

        return <BottomSheet open={true} 
                        defaultSnap={({ maxHeight }) => Math.trunc(maxHeight * 0.80)}
                        snapPoints={({ minHeight, maxHeight }) => [Math.trunc(maxHeight * 0.80), Math.trunc(maxHeight * 0.80)]}

                        header={headerComponent}
                        footer={footerComponent}
                        onDismiss={()=>
                                    {
                                        this.props.onDismiss();
                                    }
                                  }
                >
                    <div style={{marginBottom:'30px'}}>
                        {this.renderModifiers()}
                    </div>
                </BottomSheet>
    }

    renderModifiers()
    {
        var childComponents = [];
        for (var index = 0; index < this.state.modifierModel.modifierGroupModels.length; index++)
        {
            this.renderModifier(this.state.modifierModel.modifierGroupModels[index], childComponents);
        }

        return <div>
                    {childComponents}
                </div>
    }

    renderModifier(modifierGroupModel, childComponents)
    {
        if (modifierGroupModel.modifier.items.length == 1 &&
            modifierGroupModel.modifier.min == 1 && 
            modifierGroupModel.modifier.max == 1)
            {
                modifierGroupModel.quantity = 1;
                return;
            }
            
        var caption = `${modifierGroupModel.modifier.caption} (Optional)`
        if (modifierGroupModel.modifier.min > 0)
            caption = `${modifierGroupModel.modifier.caption} (Required)`;

        childComponents.push(<div style={{background:`var(--menu-modifier-background-color)`, 
                                          color:`var(--menu-modifier-font-color)`, 
                                          fontSize:`var(--menu-modifier-font-size)`, 
                                          paddingLeft:'10px',
                                          paddingRight:'10px',
                                          paddingTop:'20px',
                                          paddingBottom:'20px',
                                          fontWeight:'bold',
                                          }}>
                                {caption}
                             </div>)

        for (var index = 0; index < modifierGroupModel.modifierModels.length; index++)
        {
            this.renderModifierItem(modifierGroupModel, modifierGroupModel.modifierModels[index], childComponents);
        }
    }

    renderModifierItem(modifierGroupModel, modifierModel, childComponents)
    {
        var style = {};
        style.display = 'inline';
        var disabled = false;

        if (modifierModel.modifier.isSnoozed)
            disabled = true;

        if (modifierModel.quantity <= 0 && !modelUtil.canSelectMoreModifiers(modifierGroupModel))
            disabled = true;

        if (disabled)
            style.color = `var(--muted-text-color)`;

        var selectedQuantity = null;
        var deleteIcon = null;
        if (modifierModel.quantity > 0)
        {
            deleteIcon = <span style={{marginLeft:'5px', marginRight:'40px'}}
                               onClick={(event)=>
                               {
                                    modelUtil.removeItemModel(modifierModel);
                                    this.setState({});
                                    event.stopPropagation();
                               }} >
                            <RiDeleteBin5Line size={20}/>
                        </span>
            if (modifierModel.quantity > 1)
                selectedQuantity = <span style={{borderLeft:`var(--selected-modifier-item-border)`, marginRight:'5px'}}>
                                        <h4 style={{marginLeft:'2px', 
                                                    display: 'inline',
                                                    color: `var(--selected-modifier-quantity-font-color)`}}>{modifierModel.quantity}x</h4>
                                    </span>
            else
                selectedQuantity = <span style={{borderLeft:`var(--selected-modifier-item-border)`, marginRight:'5px'}}>
                                    </span>
        }

        var subModifierComponent = null;
        if (modifierModel.quantity > 0 && modifierModel.modifierGroupModels.length > 0)
            subModifierComponent = <SubModifierComponent modifierModel={modifierModel}
                                    onEditSelection={()=>
                                        {
                                            this.state.selectedModifierModel = modifierModel;
                                            this.setState({});
                                        }}/>


        childComponents.push(
                                <div style={{
                                                paddingLeft:'20px', 
                                                paddingRight:'20px',
                                                paddingTop:'8px', 
                                                paddingBottom:'8px'}}
                                                
                                    onClick={()=>
                                        {
                                            if (disabled || !modelUtil.canSelectMoreModifiers(modifierGroupModel))
                                                return;

                                            if (modifierGroupModel.quantity > 0 && !modelUtil.multipleSelectionAllowedInModifierGroupModel(modifierGroupModel))
                                                return;

                                            modifierModel.quantity = modifierModel.quantity + 1;
                                            if (modifierModel.quantity == 1 && modifierModel.modifierGroupModels.length > 0)
                                            {
                                                this.state.selectedModifierModel = modifierModel;
                                            }

                                            this.setState({});
                                        }}>

                                    
                                    <table>
                                        <tr>
                                            <td style={{width:'99%'}}>
                                                {selectedQuantity}<h4 style={style}>{modifierModel.modifier.caption}</h4>
                                                
                                            </td>
                                            <td>
                                                {deleteIcon}
                                            </td>
                                            <td>
                                                <h4 style={style}> {formatter.convertToCurrencyFormat(modifierModel.modifier.price)}</h4>
                                            </td>
                                        </tr>
                                    </table>
                                    {subModifierComponent}
                                </div>
        )
    }
}

export default ModifierComponent;